export default "__VITE_ASSET__B_Rf4V1T__"